import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dialog",
    "searchInput",
    "manufacturerItem",
    "manufacturerRadio",
    "newManufacturerInput",
    "emptyState",
    "errorMessage"
  ]

  connect() {
    this.filter()
  }

  openModal(event) {
    event.preventDefault()
    if (!this.hasDialogTarget) return

    this.dialogTarget.classList.remove("hidden")
    this.dialogTarget.classList.add("flex")
    this.clearError()

    if (this.hasNewManufacturerInputTarget) {
      this.newManufacturerInputTarget.value = this.newManufacturerInputTarget.dataset.defaultValue || ""
      this.manufacturerRadioTargets.forEach((radio) => {
        radio.checked = false
      })
    }

    if (this.hasSearchInputTarget) {
      this.searchInputTarget.value = ""
      this.filter()
      this.searchInputTarget.focus()
    }
  }

  closeModal(event) {
    if (event) event.preventDefault()
    if (!this.hasDialogTarget) return

    this.dialogTarget.classList.add("hidden")
    this.dialogTarget.classList.remove("flex")
    this.clearError()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) {
      this.closeModal()
    }
  }

  filter() {
    const query = this.hasSearchInputTarget ? this.searchInputTarget.value.trim().toLowerCase() : ""
    let visibleCount = 0

    this.manufacturerItemTargets.forEach((item) => {
      const name = item.dataset.manufacturerSearch || ""
      const isVisible = query.length === 0 || name.includes(query)
      item.classList.toggle("hidden", !isVisible)
      if (isVisible) visibleCount += 1
    })

    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.toggle("hidden", visibleCount > 0)
    }
  }

  onExistingSelection() {
    if (!this.hasNewManufacturerInputTarget) return

    this.newManufacturerInputTarget.value = ""
    this.clearError()
  }

  onNewNameInput() {
    if (!this.hasNewManufacturerInputTarget) return

    const typedName = this.newManufacturerInputTarget.value.trim()
    if (typedName.length > 0) {
      this.manufacturerRadioTargets.forEach((radio) => {
        radio.checked = false
      })
    }

    this.clearError()
  }

  validateSubmit(event) {
    const selectedId = this.selectedManufacturerId()
    const newName = this.hasNewManufacturerInputTarget ? this.newManufacturerInputTarget.value.trim() : ""

    if (selectedId || newName.length > 0) return

    event.preventDefault()
    this.showError("Wybierz producenta z listy albo wpisz nazwe nowego.")
  }

  selectedManufacturerId() {
    const selected = this.manufacturerRadioTargets.find((radio) => radio.checked)
    return selected ? selected.value : null
  }

  showError(message) {
    if (!this.hasErrorMessageTarget) return

    this.errorMessageTarget.textContent = message
    this.errorMessageTarget.classList.remove("hidden")
  }

  clearError() {
    if (!this.hasErrorMessageTarget) return

    this.errorMessageTarget.textContent = ""
    this.errorMessageTarget.classList.add("hidden")
  }
}
